import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

// Purely presentational — it also renders for data-miss states on routes that
// carry customer identifiers, so Sentry reporting happens at the route-level
// 404 branch in app/root.tsx, not here.
export const NotFound = () => {
  const { t } = useTranslation();
  return (
    <section className='flex flex-1 items-center justify-center py-16 font-mono'>
      <div className='text-center space-y-6'>
        <div className='flex items-center justify-center'>
          <svg width='120' height='120' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg' className='text-primary' aria-hidden='true' role='img'>
            <g>
              <path d='M85 63.5343V74H51.0905V63.5343H85ZM45.5379 50.7346L22.4815 73.8651L15 66.4994L31.0024 50.4456L15.0074 33.0627L22.7789 26L45.5379 50.7346Z' fill='currentColor'>
                <animate attributeName='opacity' values='0.7;1;0.7' dur='2.5s' repeatCount='indefinite' />
              </path>
            </g>
          </svg>
        </div>
        <h1 className='text-6xl font-bold tracking-tight'>404</h1>
        <p className='text-base text-muted-foreground'>{t('common.notFoundDescription')}</p>
        <div className='flex items-center justify-center gap-4'>
          <Link to='/' className='inline-flex h-10 items-center rounded-md bg-primary px-6 text-sm font-medium text-primary-foreground shadow hover:opacity-90'>
            {t('common.goToHome')}
          </Link>
        </div>
      </div>
    </section>
  );
};
